import React from "react"
import { Box, BoxProps } from "@chakra-ui/core"
import { FormProvider } from "react-hook-form"
import FormBox from "../common/FormBox"
import FormTitle from "../common/FormTitle"
import FormSubtitle from "../common/FormSubtitle"
import FormDescription from "../common/FormDescription"
import FormFieldsLayout from "../common/FormFieldsLayout"
import { ConnectedTextField as TextField } from "../../FormFields/TextField"
import { ConnectedTextAreaField as TextAreaField } from "../../FormFields/TextAreaField"
import { ConnectedDateField as DateField } from "../../FormFields/DateField"
import StoreSelectField from "../common/StoreSelectField"
import Body from "../../typography/Body"
import { Button } from "../../Buttons"
import useGoogleForm from "../../../hooks/useGoogleForm"
import config from "../../../config"
import SuccessWrapper from "./SuccessWrapper"

type ShippingAddressChangeFormProps = BoxProps & {}

export default function ShippingAddressChangeForm({
  ...props
}: ShippingAddressChangeFormProps) {
  const { methods, onSubmit, isSubmitting, success, error } = useGoogleForm<{}>(
    {
      sheetsId: config.GATSBY_SHIPPING_ADDRESS_GOOGLE_SHEETS_ID,
    }
  )

  return (
    <FormProvider {...methods}>
      <FormBox {...props} onSubmit={methods.handleSubmit(onSubmit)}>
        <SuccessWrapper success={success}>
          <FormTitle>Shipping Address Change Request</FormTitle>
          <FormDescription>
            Interested in changing your shipping address? We&apos;re here to
            help. We have a larger amount of inquires than normal and we&apos;re
            working through the requests as quickly as possible. We appreciate
            your patience.
            <br />
            <br />
            Please complete the form below and our team will be notified
            you&apos;re in the queue to be helped.
          </FormDescription>
          <FormFieldsLayout mb="2.9531rem">
            <TextField
              name="Name on order"
              placeholder="Name on Order"
              isRequired
            />
            <TextField
              name="Email Address"
              placeholder="Email address"
              type="email"
              isRequired
            />
            <DateField name="Order Date" placeholder="Order Date" isRequired />
            <StoreSelectField name="Where did you purchase your bike?" />
            <TextField
              name="Order Number"
              placeholder="Order Number"
              isRequired
            />
          </FormFieldsLayout>
          <FormSubtitle mb="0.5rem">
            What address would you like us to ship your order to?
          </FormSubtitle>
          <Body size="sm" color="dusk" mb="0.5rem">
            Please enter your shipping address below. Note: we are unable to
            ship to PO Boxes or APO&apos;s
          </Body>
          <TextField
            name="What address would you like us to ship your order to? "
            placeholder="Shipping address"
            mb="1.0856rem"
          />
          <TextAreaField
            name="Additional Comments"
            placeholder="Additional comments"
          />
          <Box textAlign="center" mt="4.32rem">
            <Button theme="primary" type="submit" isLoading={isSubmitting}>
              Submit
            </Button>
          </Box>
          {error && (
            <Body mt="2rem" color="sunrise">
              {error}
            </Body>
          )}
        </SuccessWrapper>
      </FormBox>
    </FormProvider>
  )
}
